import { render } from "./Time.vue?vue&type=template&id=23b5d787"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=23b5d787&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Time.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b5d787"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b5d787', __exports__)) {
    api.reload('23b5d787', __exports__)
  }
  
  module.hot.accept("./Time.vue?vue&type=template&id=23b5d787", () => {
    api.rerender('23b5d787', render)
  })

}


export default __exports__